
if (!customElements.get('cm-payment-modal')) {
  customElements.define('cm-payment-modal', class CMPaymentModal extends HTMLElement {
    
    

    connectedCallback() {
      if (this._inited) return;          
      this._inited = true;
      this.triggerBtn = this.querySelector('.cm-payment-modal__trigger');
      this.closeBtn = this.querySelector('.cm-payment-modal__close');
      this.overlay = this.querySelector('.cm-payment-modal__overlay');
      this.tabBtns = this.querySelectorAll('.cm-payment-modal__tab-btn');
      this.panels = this.querySelectorAll('.cm-payment-modal__panel');
      this.installmentsContainer = this.querySelector('.cm-payment-modal__installments');
      this.bindEvents();
    }

    bindEvents() {
      
      if (this.triggerBtn) this.triggerBtn.addEventListener('click', () => this.open());
      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());
      if (this.overlay) this.overlay.addEventListener('click', (e) => { if (e.target === this.overlay) this.close(); });
      if (this.tabBtns && this.tabBtns.length) {
        this.tabBtns.forEach(btn => {
          btn.addEventListener('click', (e) => this.switchTab(e.currentTarget));
          
          btn.addEventListener('keydown', (e) => this.handleTabKeydown(e));
        });
      }
    }

    open() {
      this.previouslyFocused = document.activeElement;
      this.overlay.setAttribute('open', '');
      this.overlay.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      if (this.triggerBtn) this.triggerBtn.setAttribute('aria-expanded', 'true');
      this.generateInstallments();
      
      const firstFocusable = this.overlay.querySelector(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (firstFocusable) firstFocusable.focus();
      
      this._escHandler = (e) => { if (e.key === 'Escape') this.close(); };
      this._trapHandler = (e) => this.trapFocus(e);
      document.addEventListener('keydown', this._escHandler);
      this.overlay.addEventListener('keydown', this._trapHandler);
    }

    close() {
      this.overlay.removeAttribute('open');
      this.overlay.style.display = 'none';
      document.body.style.overflow = '';
      if (this.triggerBtn) this.triggerBtn.setAttribute('aria-expanded', 'false');
      
      if (this._escHandler) document.removeEventListener('keydown', this._escHandler);
      if (this._trapHandler) this.overlay.removeEventListener('keydown', this._trapHandler);
      
      if (this.previouslyFocused && typeof this.previouslyFocused.focus === 'function') {
        this.previouslyFocused.focus();
      }
    }

    trapFocus(e) {
      if (e.key !== 'Tab') return;
      const focusables = Array.from(this.overlay.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(el => !el.hasAttribute('hidden') && el.offsetParent !== null);
      if (focusables.length === 0) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    handleTabKeydown(e) {
      const tabs = Array.from(this.tabBtns).filter(t => t.offsetParent !== null);
      const currentIdx = tabs.indexOf(e.currentTarget);
      if (currentIdx === -1) return;
      let nextIdx = null;
      if (e.key === 'ArrowRight') nextIdx = (currentIdx + 1) % tabs.length;
      else if (e.key === 'ArrowLeft') nextIdx = (currentIdx - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') nextIdx = 0;
      else if (e.key === 'End') nextIdx = tabs.length - 1;
      if (nextIdx !== null) {
        e.preventDefault();
        tabs[nextIdx].focus();
        this.switchTab(tabs[nextIdx]);
      }
    }

    switchTab(selectedBtn) {
      const targetId = selectedBtn.getAttribute('aria-controls');
      this.tabBtns.forEach(btn => {
        btn.setAttribute('aria-selected', 'false');
        btn.setAttribute('tabindex', '-1');
      });
      selectedBtn.setAttribute('aria-selected', 'true');
      selectedBtn.setAttribute('tabindex', '0');
      this.panels.forEach(panel => {
        panel.id === targetId ? panel.removeAttribute('hidden') : panel.setAttribute('hidden', '');
      });
    }

    generateInstallments() {
      if (!this.installmentsContainer || this.installmentsContainer.innerHTML !== '') return;
      const price = parseFloat(this.dataset.price);
      const maxInst = parseInt(this.dataset.maxInstallments);
      const minVal = parseFloat(this.dataset.minInstallment);
      const noInterest = parseInt(this.dataset.noInterest);
      const interestTable = [0, 3.99, 5.38, 6.37, 7.36, 8.35, 9.34, 10.08, 11.07, 12.06, 13.05, 14.04, 15.03, 16.02, 17.01, 18.00, 18.99, 19.98, 20.97];

      let actualMax = Math.min(maxInst, Math.floor(price / minVal), 18);
      if (actualMax < 1) actualMax = 1;

      let html = '';
      const fmt = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

      for (let i = 1; i <= actualMax; i++) {
        let val, label;
        if (i <= noInterest) {
          val = price / i; label = 'Sem juros';
        } else {
          val = (price * (1 + (interestTable[i] / 100))) / i; label = 'Com juros';
        }
        html += `<div class="cm-payment-modal__installment-row"><span><strong>${i}x</strong> de ${fmt.format(val)}</span><span>${label}</span></div>`;
      }
      this.installmentsContainer.innerHTML = html;
    }
  });
}